export default __webpack_public_path__ + "static/media/blackberry.5827a36d.jfif";